import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { LangContext } from "../../contexts/LangContext";
import { LangSwitchSidebar } from "../Common/LangSwitch";
import { LogoSVG } from "../Common/LogoSVG";
import en from "../../i18n/en";
import pl from "../../i18n/pl";
import { getCookie, setCookie } from "../../services/cookie";

export function Sidebar({ userEmail, balance, onLogout, onShowSupport }) {
  const { lang } = React.useContext(LangContext);
  const t = lang === "pl" ? pl : en;
  const [mobileMenuOpen, setMobileMenuOpen] = React.useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const ADMIN_IDS = [13];
  const userInfoObj = JSON.parse(getCookie('userInfo') || '{}');
  const isAdmin = ADMIN_IDS.includes(userInfoObj?.id);
  const adminPages = isAdmin ? [{ key: "outreach", label: "📢 Outreach", icon: "📢" }] : [];

  const navItems = [
    { id: "tasks", path: "/tasks", icon: "📋", label: t.sidebar.myTasks },
    { id: "select-create", path: "/select-create", icon: "＋", label: t.sidebar.newTask },
    { id: "visualization", path: "/visualization", icon: "👁️", label: t.sidebar.visualization },
    { id: "balance", path: "/balance", icon: "💰", label: t.sidebar.balance },
    { id: "referrals", path: "/referrals", icon: "🔗", label: t.sidebar.referrals },
   

    ...(isAdmin ? [{ id: "outreach", path: "/outreach", icon: "📢", label: "Outreach" }] : []),
    ...(isAdmin ? [{ id: "sender", path: "/sender", icon: "📢", label: "Sender" }] : []),
  ];

  // Определяем, активен ли путь
  const isActive = (path) => {
    if (path === "/tasks" && (location.pathname === "/" || location.pathname === "/tasks")) {
      return true;
    }
    return location.pathname === path;
  };

  const handleNavClick = (path) => {
    navigate(path);
    setMobileMenuOpen(false);
  };

  const handleLogout = () => {
    onLogout();
    setMobileMenuOpen(false);
  };

  const handleSupport = () => {
    onShowSupport();
    setMobileMenuOpen(false);
  };

  return (
    <>
      {/* Mobile hamburger button */}
      <button 
        className="mobile-menu-toggle"
        onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        aria-label="Toggle menu"
      >
        {mobileMenuOpen ? "✕" : "☰"}
      </button>

      {/* Overlay for mobile */}
      {mobileMenuOpen && (
        <div 
          className="sidebar-overlay"
          onClick={() => setMobileMenuOpen(false)}
        />
      )}

      <aside className={`sidebar ${mobileMenuOpen ? 'mobile-open' : ''}`}>
        <div className="sidebar-brand">
          <div className="sidebar-brand-icon">
            <LogoSVG size={18} />
          </div>
          <h2>{t.appName}</h2>
        </div>

        <nav className="sidebar-nav">
          {navItems.map((item) => (
            <button
              key={item.id}
              className={`nav-item ${isActive(item.path) ? "active" : ""}`}
              onClick={() => handleNavClick(item.path)}
            >
              <span className="nav-icon">{item.icon}</span>
              {item.label}
            </button>
          ))}
          <div style={{ flex: 1 }} />

          <button className="nav-item" onClick={handleSupport}>
            <span className="nav-icon">💬</span>
            {t.support}
          </button>
        </nav>

        <div className="sidebar-footer">
          <LangSwitchSidebar />
          <div className="sidebar-user">
            <div className="sidebar-user-avatar">
              {userEmail.charAt(0).toUpperCase()}
            </div>
            <div>
              <div className="sidebar-user-email">{userEmail}</div>
              
            </div>
          </div>
          <button className="btn-logout" onClick={handleLogout}>
            <span>⬡</span> {t.sidebar.signOut}
          </button>
        </div>
      </aside>
    </>
  );
}